// Chuông header + popover (plan 261023-2005 phase 02). Badge đỏ = tổng chưa đọc, chấm cam = "Cần xử lý" chưa đọc.
import React, { useCallback, useEffect, useState } from 'react'
import { Badge, Popover, Tabs, Spin } from 'antd'
import { BellOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from 'consts'
import { getNotifications, markNotificationsRead, markAllNotificationsRead } from 'apis/notifications'
import useNotificationFeed from './use-notification-feed'
import NotificationListItem from './notification-list-item'
import { TABS, orderLinkOf } from './notification-meta'
import styles from './notification-bell.module.scss'

const POP_SIZE = 8

export default function NotificationBell() {
  const navigate = useNavigate()
  const { counts, latest, refresh } = useNotificationFeed()
  const [open, setOpen] = useState(false)
  const [tab, setTab] = useState('all')
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(false)

  const load = useCallback(async (t) => {
    setLoading(true)
    try {
      const res = await getNotifications({ tab: t === 'all' ? undefined : t, pageSize: POP_SIZE })
      if (res.status === 200 && res.data.success) setItems(res.data.data || [])
    } catch (e) {}
    setLoading(false)
  }, [])

  // Mở popover: còn tin cần xử lý chưa đọc thì mở tab "Cần xử lý".
  const onOpenChange = (v) => {
    setOpen(v)
    if (v) {
      const t = counts.action > 0 ? 'action' : 'all'
      setTab(t)
      load(t)
      refresh()
    }
  }

  // Tin mới qua socket khi popover đang mở ⇒ chèn đầu list.
  useEffect(() => {
    if (open && latest) setItems((prev) => (prev.some((x) => x._id === latest._id) ? prev : [latest, ...prev].slice(0, POP_SIZE)))
  }, [latest]) // eslint-disable-line react-hooks/exhaustive-deps

  const onClickItem = async (item) => {
    if (!item.read_at) {
      setItems((prev) => prev.map((x) => (x._id === item._id ? { ...x, read_at: new Date().toISOString() } : x)))
      try { await markNotificationsRead([item._id]) } catch (e) {}
      refresh()
    }
    const link = orderLinkOf(item)
    if (link) { setOpen(false); navigate(link) }
  }

  const onReadAll = async () => {
    try { await markAllNotificationsRead(tab === 'all' ? {} : { tab }) } catch (e) {}
    load(tab)
    refresh()
  }

  const content = (
    <div className={styles.pop}>
      <div className={styles.head}><b>Thông báo</b><a onClick={onReadAll}>Đánh dấu tất cả đã đọc</a></div>
      <Tabs size="small" tabBarGutter={14} activeKey={tab} onChange={(k) => { setTab(k); load(k) }}
        items={TABS.map((t) => ({ key: t.key, label: t.key === 'action' && counts.action ? <span>{t.label} <Badge count={counts.action} size="small" /></span> : t.label }))} />
      <Spin spinning={loading}>
        <div className={styles.list}>
          {items.length ? items.map((it) => <NotificationListItem key={it._id} item={it} onClick={onClickItem} />)
            : <div className={styles.empty}>Chưa có thông báo</div>}
        </div>
      </Spin>
      <div className={styles.foot}>
        <span>Bấm 1 dòng → mở đơn</span>
        <a onClick={() => { setOpen(false); navigate(ROUTES.NOTIFICATIONS) }}>Xem tất cả →</a>
      </div>
    </div>
  )

  return (
    <Popover content={content} placement="bottomRight" trigger="click" open={open} onOpenChange={onOpenChange} rootClassName={styles.popRoot}>
      <span className={styles.trigger}>
        <Badge count={counts.count} overflowCount={99} size="small">
          <BellOutlined style={{ fontSize: '1.25rem', color: 'rgba(0,0,0,.65)' }} />
        </Badge>
        {counts.action > 0 && <span className={styles.actionDot}>{counts.action > 99 ? '99+' : counts.action}</span>}
      </span>
    </Popover>
  )
}
